export default [
    { text: 'Fornecedor', sortable: false, value: 'provider' },
    { text: 'Número', sortable: false, value: 'number', align: 'center' },
    { text: 'Valor', sortable: false, value: 'value', align: 'center',  width: 160 },
    { text: 'Emissão', sortable: false, value: 'issuedAt', align: 'center',  width: 144},
    { text: 'Vencimento', sortable: false, value: 'dueDate', align: 'center',  width: 144 },
];
